import React from 'react';
import PropTypes from 'prop-types';
import Dimmer from './Dimmer';
import ErrorDialog from './ErrorDialog';
import Icon from '@projeccions-pdc/react-icon';
import Dropzone from 'react-dropzone';
import Tagger from './Tagger';
import YesNoModal from './YesNoModal';
import * as shortid from 'shortid';
import FileService from '../../apiclients/FileService';
import LocalizedStrings from './localization.js';
import PromiseConsumer from './PromiseConsumer';
import Button from '@material-ui/core/Button';
import './css/library.css';
import { libraryStyle } from './stylesParser';
import HomeController from './HomeController';
import StoreController from '@projeccions-pdc/frontend-storage';
import FileUpload from './FileUpload';
import GroupSelector from '../Common/GroupSelector/GroupSelector';
import { cloneDeep } from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import AppContext from '../../AppContext';

let initalGroups = { max: 1, values: [] };

class LibraryUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            files: {},
            showModal: false,
            showErrorModal: false,
            uploadingFiles: false,
            activeGroups: cloneDeep(initalGroups),
            session: shortid(),
            shareable: false,

            showMd5Dialog: false,
        };

        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let myInfo = appContext.getMyInfo();
        let userSub = myInfo ? myInfo.userSub : 'userAnonim';
        this._storeController = new StoreController(platformId, userSub);
        this._homeController = new HomeController(this, this._storeController);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.files) {
            return { files: props.files };
        }
        return null;
    }

    handleDeleteTag = (tag) => {
        this.setState({
            tags: this.state.tags.filter((t) => t !== tag),
        });
    };

    handleBrowseClick = () => {
        this.refs.dropzone.open();
    };

    fileAlreadyExists = (file) => {
        let files = this.state.files ? Object.keys(this.state.files) : [];
        for (let i = 0; i < files.length; i++) {
            let currKey = files[i];
            let currFile = this.state.files[currKey];
            if (currFile.file.name === file.name) {
                return true;
            }
        }
        return false;
    };

    onDropFiles = (newFiles) => {
        let stateFiles = cloneDeep(this.state.files);
        newFiles.forEach((element, index) => {
            if (this.fileAlreadyExists(element) === false) {
                const newElement = {
                    file: element,
                    progress: 0,
                };
                const id = shortid();
                stateFiles[id] = newElement;
            }
        });
        this.setState({
            files: stateFiles,
        });
    };

    onAlreadyInLibraryLoaded = (internalFileId, alreadyInLibrary) => {
        let stateFiles = cloneDeep(this.state.files);
        stateFiles[internalFileId].alreadyInLibrary = alreadyInLibrary;
        this.setState({ files: stateFiles });
    };

    handleDeleteFile = (fileID) => {
        let stateFiles = cloneDeep(this.state.files);
        delete stateFiles[fileID];
        this.setState({
            files: stateFiles,
        });
    };

    handleCancelClick = () => {
        if (this.state.tags.length > 0 || Object.keys(this.state.files).length > 0) {
            this.setState({ showModal: true });
        }
    };

    handleCancelAcion = () => {
        this.setState({
            tags: [],
            currentTag: '',
            files: [],
        });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };

    handleCloseErrorModal = () => {
        this.setState({ showErrorModal: false });
    };

    fileProgressCallback = (p) => {
        var newState = cloneDeep(this.state.files);
        newState[p.elementId].progress = p.progress;
        this.setState({ files: newState });
    };

    getAlreadyInLibraryFiles = () => {
        let files = [];
        Object.keys(this.state.files).forEach((fileID) => {
            let file = this.state.files[fileID];
            if (file.alreadyInLibrary === true) {
                files.push(file);
            }
        });
        return files;
    };

    handleUploadClick = () => {
        if (this.getAlreadyInLibraryFiles().length > 0) {
            this.setState({ showMd5Dialog: true });
        } else {
            this.uploadFiles();
        }
    };

    handleCloseMd5Modal = () => {
        this.setState({ showMd5Dialog: false });
    };

    uploadFiles = () => {
        const activeGroups = this.state.activeGroups;
        let canProceed = true;

        let appContext = new AppContext();

        let myInfo = appContext.getMyInfo();

        if (!myInfo.isAdmin && (activeGroups.values.length === 0 || activeGroups.values === undefined)) {
            canProceed = false;
            this.props.notify('error', 'A user group must be defined for this upload');
            return;
        }
        if (this.state.tags.length > 0 && Object.keys(this.state.files).length > 0 && canProceed) {
            this.setState({ uploadingFiles: true });
            this.uploadOps = [];
            let groupId =
                this.state.activeGroups.values && this.state.activeGroups.values.length > 0 ? this.state.activeGroups.values[0] : undefined;
            let elements = [];
            for (let elementKey of Object.keys(this.state.files)) {
                elements.push({
                    key: elementKey,
                    file: this.state.files[elementKey].file,
                    groupId: groupId,
                });
            }
            elements.reverse();
            let promiseConsumer = new PromiseConsumer(4, elements, this.uploadFileAction, this.finishFilesUpload);
            promiseConsumer.consume();
        } else {
            this.setState({ showErrorModal: true });
            this.setState({ uploadingFiles: false });
        }
    };

    uploadFileAction = (currentElement, actionFinishedCallback) => {
        FileService.uploadFile(
            currentElement.file,
            currentElement.file.name,
            currentElement.groupId,
            currentElement.file.type,
            this.state.session,
            this.state.tags,
            this.state.shareable,
            currentElement.key,
            this.fileProgressCallback
        )
            .then((response) => {
                if (actionFinishedCallback) {
                    actionFinishedCallback(response);
                }
            })
            .catch((err) => {
                console.log('Some files were not uploaded');
                console.log('err');
                console.log(err);
                if (actionFinishedCallback) {
                    actionFinishedCallback('ko');
                }
            });
    };

    finishFilesUpload = (responses) => {
        // console.log(responses);
        // console.log('All files uploaded!');
        const activeGroups = this.state.activeGroups;
        this.setState({
            tags: [],
            currentTag: '',
            files: [],
        });
        let structuredUploads = { file: [], image: [], video: [] };
        responses.forEach((response) => {
            structuredUploads[response.fileData.fileType].push(response.fileData);
        });
        this.setState({ uploadingFiles: false });
        let filter = undefined;
        if (activeGroups.values !== undefined && activeGroups.values.length > 0) {
            filter = this.state.groupInfo;
        }
        this._homeController.saveSession(this.state.session);
        this.props.loadCurrentSession(this.state.session, structuredUploads, filter);
    };

    handleAddTag = (values) => {
        let tags = [];
        values.forEach((currVal) => {
            if (tags.indexOf(currVal) === -1) {
                tags.push(currVal.value);
            }
        });
        this.setState({ tags });
    };

    handleSelectedGroupResult = (groupId, group) => {
        if (groupId) {
            if (this.state.activeGroups.max === -1 || this.state.activeGroups.values.length < this.state.activeGroups.max) {
                if (this.state.activeGroups.values.indexOf(groupId) === -1) {
                    let activeGroups = cloneDeep(this.state.activeGroups);
                    activeGroups.values.push(groupId);
                    this.setState({ activeGroups, groupInfo: group });
                }
            }
        }
    };

    handleDeleteGroup = () => {
        this.setState({ activeGroups: cloneDeep(initalGroups), groupInfo: undefined });
    };

    onChangeShareable = (evt) => {
        this.setState({ shareable: evt.target.checked });
    };

    render() {
        const filesComponents = Object.keys(this.state.files).map((key) => (
            <FileUpload
                key={key}
                fileID={key}
                element={this.state.files[key]}
                handleDeleteFile={this.handleDeleteFile}
                onAlreadyInLibraryLoaded={this.onAlreadyInLibraryLoaded}
            />
        ));

        return (
            <div>
                <Dimmer active={this.state.uploadingFiles} />

                <Dropzone
                    data-id="library-upload-dropzone"
                    ref="dropzone"
                    className={libraryStyle.dropzone}
                    disableClick={true}
                    onDrop={this.onDropFiles}
                >
                    <div className={libraryStyle.dropzoneContainer}>
                        <div className={libraryStyle.dropzoneContent}>
                            {filesComponents.length > 0 ? (
                                <div>{filesComponents}</div>
                            ) : (
                                <div className={libraryStyle.dropzoneMessage}>{LocalizedStrings.dragDropZone}</div>
                            )}
                            <div className={libraryStyle.dropzoneBrowse}>
                                <Button variant="outlined" onClick={this.handleBrowseClick}>
                                    {LocalizedStrings.browseFiles}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={libraryStyle.dropAreaActionsContainer}>
                        <Button variant="outlined" onClick={this.handleCancelClick}>
                            {LocalizedStrings.cancel}
                        </Button>
                        <YesNoModal
                            size={'small'}
                            open={this.state.showModal}
                            handleClose={this.handleCloseModal}
                            handleYes={this.handleCancelAcion}
                            title={LocalizedStrings.cancelAction}
                            message={LocalizedStrings.cancelActionMessage}
                            positive={LocalizedStrings.yes}
                            negative={LocalizedStrings.no}
                        />
                        <YesNoModal
                            size={'small'}
                            open={this.state.showMd5Dialog}
                            handleClose={this.handleCloseMd5Modal}
                            handleYes={this.uploadFiles}
                            title={LocalizedStrings.md5Title}
                            message={
                                <span>
                                    {LocalizedStrings.md5Message}
                                    <br />
                                    <ul>
                                        {this.getAlreadyInLibraryFiles().map((file) => {
                                            return <li key={file.file.name}>{file.file.name}</li>;
                                        })}
                                    </ul>
                                </span>
                            }
                            positive={LocalizedStrings.yes}
                            negative={LocalizedStrings.no}
                        />
                        {'  '}
                        <Button variant="outlined" onClick={this.handleUploadClick}>
                            <Icon name="fa-upload" />
                            {'  '}
                            {LocalizedStrings.upload}
                        </Button>
                        <ErrorDialog
                            //size={'small'}
                            open={this.state.showErrorModal}
                            handleClose={this.handleCloseErrorModal}
                            title={LocalizedStrings.error}
                            message={LocalizedStrings.uploadErrorMessage}
                            ok={LocalizedStrings.ok}
                        />
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <div>
                            <Icon name="md-warning" primaryColor={'#cc3300'} />
                            {' File too large, in case of images and videos please consider optimizing quality'}
                        </div>
                        <div>
                            <Icon name="md-warning" primaryColor={'#4286f4'} />
                            {' File already uploaded in the Library!'}
                        </div>
                    </div>
                </Dropzone>
                <div className={libraryStyle.uploadAttrContainer}>
                    <h3>{LocalizedStrings.tags}</h3>
                    <Tagger onResultSelected={this.handleAddTag} />
                    <br />
                    <br />
                    <h3>{LocalizedStrings.userGroup}</h3>
                    <GroupSelector
                        onGroupSelected={this.handleSelectedGroupResult}
                        selectedGroup={this.state.activeGroups.values[0]}
                        removeGroup={this.handleDeleteGroup}
                    />
                    <br />
                    <br />
                    <h3>{LocalizedStrings.shareable}</h3>
                    <Checkbox
                        data-id="library-upload-shareable"
                        checked={this.state.shareable ? this.state.shareable : false}
                        onChange={this.onChangeShareable}
                        color="primary"
                    />
                </div>
            </div>
        );
    }
}
LibraryUpload.propTypes = {
    loadCurrentSession: PropTypes.func.isRequired,
    notify: PropTypes.func.isRequired,
};

export default LibraryUpload;
